import { API_BASE } from '../utils/config';
import { apiFetch } from '../utils/apiFetch';

export const uploadPrescription = async (file: File, userId: string): Promise<string | null> => {
  try {
    // Step 1: Get presigned S3 URL from backend
    const res = await apiFetch(`${API_BASE}/prescription_presign`, {
      method: 'POST',
      body: JSON.stringify({
        filename: file.name,
        file_type: file.type,
        user_id: userId,
      }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    const { presigned_url, filekey } = data.message || data;
    if (!presigned_url || !filekey) return null;

    // Step 2: Upload file directly to S3 (no auth header — presigned URL handles auth)
    const uploadRes = await fetch(presigned_url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });
    if (!uploadRes.ok) return null;

    return filekey as string;
  } catch {
    return null;
  }
};
